import { render, staticRenderFns } from "./AssignmentItem.vue?vue&type=template&id=74267b2c&scoped=true&"
import script from "./AssignmentItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentItem.vue?vue&type=style&index=0&id=74267b2c&prod&scoped=true&lang=css&"
import style1 from "./AssignmentItem.vue?vue&type=style&index=1&id=74267b2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74267b2c",
  null
  
)

export default component.exports